<template>
  <div class="home">
  	  <b-container class="bv-example-row">
    <div>
      <b-navbar toggleable="lg" type="dark" variant="info">
        <b-navbar-brand href="/">Aircab. Le Atiende {{firstName}} {{lastName}}</b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <!--
          <b-navbar-nav>
            <b-nav-item href="#">Link</b-nav-item>
            <b-nav-item href="#" disabled>Disabled</b-nav-item>
          </b-navbar-nav>
          -->
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <!-- 
            <b-nav-form>
              <b-form-input size="sm" class="mr-sm-2" placeholder="Search"></b-form-input>
              <b-button size="sm" class="my-2 my-sm-0" type="submit">Search</b-button>
            </b-nav-form>
            -->
            <!--
            <b-nav-item-dropdown text="Lang" right>
              <b-dropdown-item href="#">EN</b-dropdown-item>
              <b-dropdown-item href="#">ES</b-dropdown-item>
              <b-dropdown-item href="#">RU</b-dropdown-item>
              <b-dropdown-item href="#">FA</b-dropdown-item>
            </b-nav-item-dropdown>
            -->
            <b-nav-item-dropdown right>
              <!-- Using 'button-content' slot -->
              <template slot="button-content"><em>Menú</em></template>
              <b-dropdown-item v-on:click="$router.push('/')">Inicio</b-dropdown-item>
              <b-dropdown-item v-on:click="$router.push('/history')">Historial</b-dropdown-item>
              <b-dropdown-item v-on:click="logout">Salir</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>

   	<router-view></router-view>

  </b-container>
  </div>
</template>

<script>
// @ is an alias to /src

  import Vue from 'vue'
  import Parse from 'parse'
  Vue.use(Parse)
  Parse.initialize("bBzZ7wYYGIpQkPPB");
  Parse.serverURL = 'https://aircab.herokuapp.com/parse'
  // Parse.initialize("BewIZ9dlh4gNBStm")
  // Parse.serverURL = 'https://aircabdev.herokuapp.com/parse'

export default {
  name: 'layout',
  components: {
  },
  data () {
    return {
      firstName: '',
      lastName: '',
    }
  },
	async created () {
	  var currentUser = Parse.User.current()
	  // console.log('home', currentUser)
	  if (!currentUser) {
	  	console.log('no logged')
	    this.$router.replace('/login')
	  } else {
      this.firstName = currentUser.get('firstName')
      this.lastName = currentUser.get('lastName')
    }
	},
	methods: {
	  async logout () {
	    let vue = this
      this.currentUser = Parse.User.current()
      this.currentSession = await Parse.Session.current()
      /*
      let query = new Parse.Query('Queue')
      // query.select('clientFirstName', 'clientLastName', 'originName', 'destinyName', 'clientPhone', 'scheludedAt', 'folio', 'status')
      query.equalTo('seller', this.currentUser)
      query.equalTo('platform', 'pos')
      query.doesNotExist('folio')
      query.equalTo('session', this.currentSession)
      let count = await query.count()

      if (count > 0) {
        alert('Viajes sin asignación de boleto físico: ' + count)
      } else {
        console.log('currentUser',this.currentUser, this.currentUser._getId(), this.currentSession)
        Parse.User.logOut().then(() => {
          vue.$router.replace('/login');
        })
      }
      */
      Parse.User.logOut().then(() => {
        vue.$router.replace('/login');
      })
	  },
	}
}
</script>
